import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserDefinedWidgetType} from '@constants/pages/user-defined-page/user-defined-widget-type';
import {StatusEventPage} from '@models/sidebar/response/status-event-page';
import {Machine} from '@models/machine/machine';
import {StatusEventPageService} from '@services/pages/status-event-page/configuration/status-event-page.service';
import {TranslateService} from '@ngx-translate/core';
import {UserDefinedWidget} from '@models/pages/user-defined-page/user-defined-widget';
import {WidgetPollingRate} from '@constants/pages/user-defined-page/widget-polling-rate';

@Component({
    selector: 'scitis-status-event-widget-configuration',
    templateUrl: './status-event-widget-configuration.component.html',
    styleUrls: ['./status-event-widget-configuration.component.scss'],
    standalone: false
})
export class StatusEventWidgetConfigurationComponent implements OnInit {

  @Input()
  widgetType: UserDefinedWidgetType = UserDefinedWidgetType.STATUS;

  @Input()
  machine: Machine = new Machine();

  @Input()
  userDefinedWidget: UserDefinedWidget = new UserDefinedWidget();

  @Output()
  isConfigurationValid: EventEmitter<boolean> = new EventEmitter<boolean>();

  statusEventPagesArray: StatusEventPage[] = [];
  isLoadingStatusEventPages: boolean = false;
  selectStatusPagePlaceholder: string = '';
  pollingRate: WidgetPollingRate[] = [];
  pollingRatePlaceholder: string = '';
  selectedPollingRate: number = 0;

  private minuteMessage = '';
  private minutesMessage = '';

  constructor(
      private statusEventPageService: StatusEventPageService,
      private translate: TranslateService) {
    this.setMessages();
    this.setPollingRates();
  }

  get statusEventPageIsSelected(): boolean {
    return !!this.userDefinedWidget.userDefinedChartDetails.statusEventPageId || !!this.userDefinedWidget.userDefinedChartDetails.statusEventPageName;
  }

  get displayNoStatusPageMessage(): boolean {
    return !this.statusEventPagesArray || this.statusEventPagesArray.length === 0;
  }

  get isPollingRateValid() {
    return this.userDefinedWidget.userDefinedChartDetails.rangeValue > 0;
  }

  ngOnInit(): void {
    this.loadStatusEventPages();
    this.emitConfigChanged();
    this.pollingRate.forEach(item => {
      if (item.pollingRateInS === this.userDefinedWidget.userDefinedChartDetails.rangeValue) {
        this.selectedPollingRate = item.pollingRateInS;
      }
    });
  }

  onStatusEventPageSelect(statusEventPage: StatusEventPage) {
    if (!statusEventPage) {
      this.isConfigurationValid.emit(false);
      return;
    }

    this.userDefinedWidget.userDefinedChartDetails.statusEventPageId = statusEventPage.id;
    this.userDefinedWidget.userDefinedChartDetails.statusEventPageName = statusEventPage.name;
    this.emitConfigChanged();
  }

  onSetPollingRate(pollingRate: WidgetPollingRate) {
    if (!pollingRate) {
      this.userDefinedWidget.userDefinedChartDetails.rangeValue = -1;
      this.emitConfigChanged();
      return;
    }

    this.userDefinedWidget.userDefinedChartDetails.rangeValue = pollingRate.pollingRateInS;
    this.emitConfigChanged();
  }

  private emitConfigChanged(): void {
    const {statusEventPageId, statusEventPageName, rangeValue} = this.userDefinedWidget.userDefinedChartDetails;
    this.isConfigurationValid.emit(!!statusEventPageId && !!statusEventPageName && !!rangeValue);
  }

  private loadStatusEventPages() {
    this.isLoadingStatusEventPages = true;
    if (!this.machine || !this.machine.id) {
      this.statusEventPagesArray = [];
      this.isLoadingStatusEventPages = false;
      return;
    }

    this.statusEventPageService.listStatusEventPagesOfMachine(this.machine.id).subscribe((statusEventPages) => {
      this.statusEventPagesArray = [...statusEventPages];
      this.isLoadingStatusEventPages = false;
    }, (error) => {
      console.log(error);
      this.isLoadingStatusEventPages = false;
    });
  }

  private setMessages(): void {
    this.selectStatusPagePlaceholder = this.translate.instant('Select status page ...');
    this.minuteMessage = this.translate.instant('minute');
    this.minutesMessage = this.translate.instant('minutes');
    this.pollingRatePlaceholder = this.translate.instant('Select polling rate...');
  }

  private setPollingRates(): void {
    this.pollingRate = [];
    for (let numberOfMinutes = 1; numberOfMinutes <= 15; numberOfMinutes++) {
      this.pollingRate.push(this.setPollingRate(numberOfMinutes));
    }
  }

  private setPollingRate(numberOfMinutes: number): WidgetPollingRate {
    return new WidgetPollingRate(`${numberOfMinutes} ${numberOfMinutes === 1 ? this.minuteMessage : this.minutesMessage}`, 60 * numberOfMinutes);
  }

}
